













import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class NavigationBarLink extends Vue {
  @Prop() readonly to!: string
  @Prop({
    default: false
  }) readonly exact?: boolean
}
